module.exports = __webpack_public_path__ + "img/b4bc817.jpg";